import React, { ComponentType } from 'react';
import { useLocation } from 'react-router';
import { RouteComponentProps } from '../interfaces/routes';

const withForcedUnmounting =
  (Component: ComponentType<RouteComponentProps>) =>
  (props: RouteComponentProps) => {
    const location = useLocation();

    return <Component {...props} key={location.key} />;
  };

export default withForcedUnmounting;
